import React from "react";
import cx from 'classnames';

import styles from "./points.module.less";

const Points = () => (
  <div className={styles.content}>
    <div className={styles.card}>
      <div className={styles.point}>
        <div className={cx(styles.icon, styles.eventOrganizers)} />
        <div className={styles.label}>For Event Organizers</div>
        <div>
          <div className={styles.text}>Boost event traffic and attendance rates.</div>
          <div className={styles.text}>Promote better communication and information exchange between visitors and exhibitors.</div>
          <div className={styles.text}>Additional revenue stream.</div>
        </div>
      </div>
      <div className={styles.point}>
        <div className={cx(styles.icon, styles.exhibitors)} />
        <div className={styles.label}>For Exhibitors</div>
        <div>
          <div className={styles.text}>Attract more attendees to visit the booth.</div>
          <div className={styles.text}>Encourage attendees to engage in conversations.</div>
          <div className={styles.text}>Automated lead generation.</div>
          <div className={styles.text}>Track performance with real-time booth visit and lead generation statistics.</div>
        </div>
      </div>
      <div className={styles.point}>
        <div className={cx(styles.icon, styles.attendees)} />
        <div className={styles.label}>For Attendees</div>
        <div>
          <div className={styles.text}>Attractive and valuable rewards.</div>
          <div className={styles.text}>Efficient visited booth information management.</div>
          <div className={styles.text}>Program gives a treasure-hunt game flavour to the event.</div>
        </div>
      </div>
    </div>
  </div>
);

export default Points;
